import React, { FC } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import styles from './RadioSelect.module.css';
import cn from 'classnames';

interface RadioOption {
  value: string;
  content: string;
}

interface RadioSelectProps {
  selectedValue: string;
  handleClick: (selected: string) => void;
  options: RadioOption[];
}

const RadioSelect: FC<RadioSelectProps> = ({
  selectedValue,
  handleClick,
  options,
}) => {
  return (
    <ButtonGroup className={cn(styles.buttonGroup)}>
      {options.map((option: RadioOption) => (
        <Button
          key={option.value}
          className={cn(styles.button)}
          variant="light"
          value={option.value}
          active={selectedValue === option.value}
          onClick={(e) => handleClick(e.currentTarget.value)}
        >
          {option.content}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default RadioSelect;
